<template>
  <div class="scheduleManagement flex">
    <!-- 左侧日历部分 -->
    <div class="left">
      <DateManage title="日程管理" v-model:time="time"></DateManage>
    </div>
    <!-- 右侧部分 -->
    <div class="right flex-1 overflow-h">
      <Content></Content>
    </div>
  </div>
</template>

<script>
import DateManage from "./date.vue";
import Content from "./content.vue";

export default {
  provide() {
    return {
      passTime: () => this.time,
      callBack: this.callBack
    };
  },
  data() {
    return {
      time: new Date(),
    };
  },
  components: {
    DateManage,
    Content,
  },
  methods: {
    // 提供给子级调用
    callBack(e) {
      this.time = e;
    }
  },
  created() {},
};
</script>
<style lang='less' scoped>
.scheduleManagement {
  padding: 27px 24px;
  min-height: 100%;
  box-sizing: border-box;
}
</style>